import { useState } from 'react';

export const useArrayState = (initialState = []) => {
    const [state, setState] = useState(initialState);

    function runCallback(callback) {
        if (typeof callback === 'function') {
            callback();
        }
    }

    function addValue(newValue, callback = null) {
        if (!state.includes(newValue)) {
            setState(prevState => ([...prevState, newValue]));
        }
        runCallback(callback);
    }

    function removePosition(indexRemove, callback = null) {
        const newState = state.filter((element, index) => index !== indexRemove);
        setState(newState);
        runCallback(callback);
    }

    function removeByCondition(condition, callback = null) {
        const newState = state.filter(condition);
        setState(newState);
        runCallback(callback);
    }

    function editPosition(index, newValue, callback = null) {
        const newState = [...state];
        newState[index] = newValue;
        setState(newState);
        runCallback(callback);
    }

    return [state, addValue, removePosition, removeByCondition, editPosition];
};
